import { __extends } from "tslib";
import { NativeMenuItem } from '../display/NativeMenuItem';
import { axCoerceString } from '@awayfl/avm2';
var ContextMenuItem = /** @class */ (function (_super) {
    __extends(ContextMenuItem, _super);
    function ContextMenuItem(caption, separatorBefore, enabled, visible) {
        if (separatorBefore === void 0) { separatorBefore = false; }
        if (enabled === void 0) { enabled = true; }
        if (visible === void 0) { visible = true; }
        var _this = _super.call(this) || this;
        caption = axCoerceString(caption);
        separatorBefore = !!separatorBefore;
        enabled = !!enabled;
        visible = !!visible;
        _this._caption = caption ? caption : '';
        _this._separatorBefore = separatorBefore;
        _this._enabled = enabled;
        _this._visible = visible;
        return _this;
    }
    Object.defineProperty(ContextMenuItem.prototype, "caption", {
        get: function () {
            return this._caption;
        },
        set: function (value) {
            value = axCoerceString(value);
            this._caption = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuItem.prototype, "separatorBefore", {
        get: function () {
            return this._separatorBefore;
        },
        set: function (value) {
            value = !!value;
            this._separatorBefore = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextMenuItem.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        set: function (value) {
            value = !!value;
            this._visible = value;
        },
        enumerable: false,
        configurable: true
    });
    // Called whenever the class is initialized.
    ContextMenuItem.classInitializer = null;
    // List of static symbols to link.
    ContextMenuItem.classSymbols = null; // [];
    // List of instance symbols to link.
    ContextMenuItem.instanceSymbols = null; // ["clone"];
    return ContextMenuItem;
}(NativeMenuItem));
export { ContextMenuItem };
